module.exports = __webpack_public_path__ + "Roboto-Regular.df7b648ce5356ea1ebce.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Regular.ttf
// module id = ../../../../../src/assets/font/roboto/Roboto-Regular.ttf
// module chunks = 29